import React from "react";
import AppNavbar from "../components/Navbar/Navbar";
import AboutSection from "../components/About/AboutSection";
import Footer from "../components/Footer/Footer";

const AboutPage = () => {
  return (
    <div>
      <AppNavbar />
      <AboutSection/>
      <Footer/>
    </div>
  );
};

export default AboutPage;
